import { addPortNode } from '../port'
import { h } from '@vue/composition-api'

// @ts-ignore
import XPicker from '@/components/picker'

export function showPicker(options: {
  title: string
  data: Array<{
    label: string
    value: any
  }>
  initialValue?: any
  onConfirm: (value: any) => any
}) {
  const destroy = addPortNode(
    h({
      mounted() {
        // @ts-ignore
        this.$nextTick(() => {
          // @ts-ignore
          this.$refs.trigger.click()
        })
      },

      render() {
        return h(
          XPicker,
          {
            props: {
              value: options.initialValue,
              title: options.title,
              data: options.data.map(item => ({
                ...item,
                name: item.label,
              })),
            },
            on: {
              confirm: (value: any) => {
                options.onConfirm(value)
                setTimeout(destroy, 4000)
              },
            },
          },
          [
            h('div', {
              ref: 'trigger',
            }),
          ],
        )
      },
    }),
  )
}
